import React from 'react';
import { Toast, ToastType } from '@everlywell/leaves';

import { INotification } from 'utils/types';
import { VISIBLE_TIME } from 'utils/hooks/useNotification';

import * as S from './styles';

interface Props {
  notification?: INotification;
  clearNotification?: () => void;
  persistent?: boolean;
}

const Notification = (props: Props) => {
  const { notification, clearNotification, persistent = false } = props;

  const handleClearNotification = () => {
    if (clearNotification) {
      clearNotification();
    }
  };

  const message = notification?.message || '';
  const details = notification?.details;
  const notificationType = notification?.type || ToastType.SUCCESS;

  return notification ? (
    <S.Wrapper data-testid={`notification-${notificationType}`}>
      <Toast
        type={notificationType}
        content={message}
        subtext={details}
        handleClose={handleClearNotification}
        visibleTime={VISIBLE_TIME}
        persistent={persistent}
      />
    </S.Wrapper>
  ) : null;
};

export default Notification;
